module.exports = __webpack_public_path__ + "static/q9_o-4af1a30bc3cc88b587c1c0075d745526.png";